/**
 * Vacances scolaires et jours fériés vaudois — source officielle :
 * DEF, « Calendrier des vacances scolaires 2023-2031 » (document fourni par l'école).
 * Uniquement les périodes à partir de 2026. Bornes incluses (le premier et le
 * dernier jour de chaque période sont grisés dans le calendrier).
 *
 * RÈGLE PROPRE À L'ÉCOLE — grandes vacances d'été uniquement :
 * 1000 ARTS s'arrête 1 semaine AVANT le début des vacances scolaires officielles
 * et reprend 1 semaine APRÈS la rentrée scolaire officielle. Les périodes marquées
 * `ete: true` ci-dessous portent les dates OFFICIELLES du canton ; les 7 jours de
 * marge de chaque côté sont ajoutés automatiquement par `etendreEte()`.
 * Les autres vacances (automne, hiver, relâches, Pâques) et les jours fériés
 * suivent exactement le calendrier officiel, sans marge.
 */
const MARGE_ETE_JOURS = 7;

const PERIODES = [
  // Année scolaire 2025-2026
  { start: "2026-06-27", end: "2026-08-16", label: "Vacances d'été", ete: true },

  // Année scolaire 2026-2027
  { start: "2026-09-21", end: "2026-09-21", label: "Lundi du Jeûne fédéral (férié)" },
  { start: "2026-10-10", end: "2026-10-25", label: "Vacances d'automne" },
  { start: "2026-12-24", end: "2027-01-10", label: "Vacances d'hiver" },
  { start: "2027-02-06", end: "2027-02-14", label: "Relâches de février" },
  { start: "2027-03-26", end: "2027-04-11", label: "Vacances de Pâques" },
  { start: "2027-05-06", end: "2027-05-07", label: "Pont de l'Ascension (férié)" },
  { start: "2027-05-17", end: "2027-05-17", label: "Lundi de Pentecôte (férié)" },

  // Année scolaire 2027-2028
  { start: "2027-07-03", end: "2027-08-22", label: "Vacances d'été", ete: true },
  { start: "2027-09-20", end: "2027-09-20", label: "Lundi du Jeûne fédéral (férié)" },
  { start: "2027-10-09", end: "2027-10-24", label: "Vacances d'automne" },
  { start: "2027-12-24", end: "2028-01-09", label: "Vacances d'hiver" },
  { start: "2028-02-12", end: "2028-02-20", label: "Relâches de février" },
  { start: "2028-04-14", end: "2028-04-30", label: "Vacances de Pâques" },
  { start: "2028-05-25", end: "2028-05-26", label: "Pont de l'Ascension (férié)" },
  { start: "2028-06-05", end: "2028-06-05", label: "Lundi de Pentecôte (férié)" },

  // Année scolaire 2028-2029
  { start: "2028-07-01", end: "2028-08-20", label: "Vacances d'été", ete: true },
  { start: "2028-09-18", end: "2028-09-18", label: "Lundi du Jeûne fédéral (férié)" },
  { start: "2028-10-14", end: "2028-10-29", label: "Vacances d'automne" },
  { start: "2028-12-23", end: "2029-01-07", label: "Vacances d'hiver" },
  { start: "2029-02-10", end: "2029-02-18", label: "Relâches de février" },
  { start: "2029-03-30", end: "2029-04-15", label: "Vacances de Pâques" },
  { start: "2029-05-10", end: "2029-05-11", label: "Pont de l'Ascension (férié)" },
  { start: "2029-05-21", end: "2029-05-21", label: "Lundi de Pentecôte (férié)" },

  // Année scolaire 2029-2030
  { start: "2029-06-30", end: "2029-08-19", label: "Vacances d'été", ete: true },
  { start: "2029-09-17", end: "2029-09-17", label: "Lundi du Jeûne fédéral (férié)" },
  { start: "2029-10-13", end: "2029-10-28", label: "Vacances d'automne" },
  { start: "2029-12-22", end: "2030-01-06", label: "Vacances d'hiver" },
  { start: "2030-02-16", end: "2030-02-24", label: "Relâches de février" },
  { start: "2030-04-19", end: "2030-05-05", label: "Vacances de Pâques" },
  { start: "2030-05-30", end: "2030-05-31", label: "Pont de l'Ascension (férié)" },
  { start: "2030-06-10", end: "2030-06-10", label: "Lundi de Pentecôte (férié)" },

  // Année scolaire 2030-2031
  { start: "2030-07-06", end: "2030-08-25", label: "Vacances d'été", ete: true },
  { start: "2030-09-16", end: "2030-09-16", label: "Lundi du Jeûne fédéral (férié)" },
  { start: "2030-10-12", end: "2030-10-27", label: "Vacances d'automne" },
  { start: "2030-12-21", end: "2031-01-05", label: "Vacances d'hiver" },
  { start: "2031-02-15", end: "2031-02-23", label: "Relâches de février" },
  { start: "2031-04-11", end: "2031-04-27", label: "Vacances de Pâques" },
  { start: "2031-05-22", end: "2031-05-23", label: "Pont de l'Ascension (férié)" },
  { start: "2031-06-02", end: "2031-06-02", label: "Lundi de Pentecôte (férié)" },
  { start: "2031-07-05", end: "2031-08-24", label: "Vacances d'été", ete: true },
];

const jour = (iso, decalage = 0) => {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + decalage);
  return d;
};

const dateLongue = (d) =>
  d.toLocaleDateString("fr-CH", { day: "numeric", month: "long" });

const isoDe = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Reprise des cours à 1000 ARTS après chaque été : une semaine après la rentrée scolaire
// officielle. Sert de source unique à `SAISON.rentree` (src/lib/dates.js) — aucune date de
// rentrée n'est donc écrite à la main dans le site.
export const RENTREES = PERIODES.filter((p) => p.ete)
  .map((p) => isoDe(jour(p.end, MARGE_ETE_JOURS + 1)))
  .sort();

export const VACANCES_SCOLAIRES = PERIODES.map((p) => {
  const marge = p.ete ? MARGE_ETE_JOURS : 0;
  const start = jour(p.start, -marge);
  // Il y a cours le samedi : si la fermeture d'été tombait un samedi, l'école ferme le
  // dimanche suivant pour ne pas supprimer la dernière séance de la saison.
  if (p.ete && start.getDay() === 6) start.setDate(start.getDate() + 1);
  const end = jour(p.end, marge);
  end.setHours(23, 59, 59, 999);
  const label = p.ete
    ? `${p.label} — l'école reprend le ${dateLongue(jour(p.end, marge + 1))} (1 semaine après la rentrée scolaire)`
    : p.label;
  return { start, end, label };
});

// ── Les Réglages de la console font foi ─────────────────────────────────────────
// `GET /api/reglages` renvoie, pour chaque saison, les semestres et les vacances tels que
// l'école les a saisis dans la console (Réglages → Calendrier des séances), sinon le
// calendrier officiel. Ils REMPLACENT sur place la liste ci-dessus : le calendrier de
// l'année, le planning, les formulaires et le bandeau « vacances » lisent tous ces deux
// tableaux. La liste codée ici ne sert plus que si la console ne répond pas.
export function appliquerCalendrierConsole(saisons) {
  if (!saisons || typeof saisons !== "object") return;
  const cles = Object.keys(saisons).sort();
  if (!cles.length) return;
  const periodes = [];
  const rentrees = [];
  let finPrecedente = null;
  cles.forEach((cle) => {
    const s = saisons[cle] || {};
    const debut = s["1"]?.debut;
    const fin = s["2"]?.fin;
    if (debut) {
      rentrees.push(String(debut).slice(0, 10));
      // L'été : du lendemain du dernier cours de la saison précédente à la veille de la reprise.
      if (finPrecedente) {
        const start = jour(finPrecedente, 1);
        const end = jour(debut, -1);
        end.setHours(23, 59, 59, 999);
        if (start <= end) {
          periodes.push({ start, end,
            label: `Vacances d'été — l'école reprend le ${dateLongue(jour(debut))}` });
        }
      }
    }
    (s.vacances || []).forEach((v) => {
      if (!v?.debut) return;
      const end = jour(String(v.fin || v.debut).slice(0, 10));
      end.setHours(23, 59, 59, 999);
      periodes.push({ start: jour(String(v.debut).slice(0, 10)), end, label: v.label || "École fermée" });
    });
    if (fin) finPrecedente = String(fin).slice(0, 10);
  });
  if (!periodes.length) return;
  // Avant la première saison connue des Réglages (l'été qui précède la rentrée), on garde
  // les fermetures du calendrier officiel : sinon août apparaissait ouvert.
  const premier = rentrees.length ? rentrees.sort()[0] : "";
  if (premier) {
    VACANCES_SCOLAIRES.filter((p) => isoDe(p.start) < premier)
      .forEach((p) => {
        const end = new Date(Math.min(p.end.getTime(), jour(premier, -1).setHours(23, 59, 59, 999)));
        periodes.push({ ...p, end });
      });
  }
  periodes.sort((a, b) => a.start - b.start);
  VACANCES_SCOLAIRES.splice(0, VACANCES_SCOLAIRES.length, ...periodes);
  if (rentrees.length) RENTREES.splice(0, RENTREES.length, ...rentrees.sort());
}
